module.exports = __webpack_public_path__ + "img/iap-cancelled.d7011b7c.svg";